import { render, staticRenderFns } from "./Pexel.vue?vue&type=template&id=70b255df&scoped=true&"
import script from "./Pexel.vue?vue&type=script&lang=js&"
export * from "./Pexel.vue?vue&type=script&lang=js&"
import style0 from "./Pexel.vue?vue&type=style&index=0&id=70b255df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b255df",
  null
  
)

export default component.exports